import React, { Component } from "react";
import { Link } from "gatsby";
import Search from "../Search/Search";
import Section from "./Section";
import getData from "../../../services/utils";

import "../../../styles/filterBar.less";

class MobileFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            openSubSection: ""
        };
        this.filterBar = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleFilterStatus, false);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleFilterStatus, false);
    }

    handleFilterStatus = (event) => {
        if (this.filterBar.current.contains(event.target)) {
            return;
        }
        this.handleFilterClose();
    };

    handleFilterClose = () => {
        this.setState({
            isOpen: false,
            openSubSection: ""
        });
    };

    handleClick = () => {
        const { isOpen } = this.state;
        if (!isOpen) {
            this.setState({
                openSubSection: ""
            });
        }
        this.setState({
            isOpen: !isOpen
        });
    };

    handleSubClick = (e, title) => {
        const { openSubSection } = this.state;
        if (openSubSection === title) {
            this.setState({
                openSubSection: ""
            });
        } else {
            this.setState({
                openSubSection: title
            });
        }
    };

    render() {
        const { isOpen, openSubSection } = this.state;
        const { vertical, resourcesLink, market, placeholder } = this.props;
        const data = getData(market, vertical);

        return (
            <MobileStateless
                isOpen={isOpen}
                openSubSection={openSubSection}
                ref={this.filterBar}
                handleClick={this.handleClick}
                handleSubClick={this.handleSubClick}
                vertical={vertical}
                market={market}
                data={data}
                resourcesLink={resourcesLink}
                placeholder={placeholder}
            />
        );
    }
}

/* eslint-disable react/display-name */
const MobileStateless = React.forwardRef(
    (
        { isOpen, openSubSection, handleClick, handleSubClick, vertical, data, resourcesLink, market, placeholder },
        ref
    ) => {
        const { navTitle, noDropDowns } = data;
        const sections = data.sections || [];
        let wrapperClass = navTitle ? "mobileFilterWrapper" : "";
        let sectionClass = "hideMobileSections";

        if (isOpen) {
            wrapperClass = "mobileFilterWrapperActive";
            sectionClass = "showMobileSections";
        }

        const mobileNested = sections.map((section) => (
            <Section
                key={section.title}
                section={section}
                openSubSection={openSubSection}
                handleSubClick={handleSubClick}
                resourcesLink={resourcesLink}
            />
        ));

        const mobileNoNested =
            noDropDowns &&
            noDropDowns.map((link) => (
                <div className="sectionTab" key={link.title}>
                    <Link className="sectionLabel" to={`${resourcesLink}${link.url_slug}/`}>
                        {link.title}
                    </Link>
                </div>
            ));

        return (
            <div className="filterBarMobile" ref={ref}>
                <Search vertical={vertical} market={market} placeholder={placeholder} resourcesLink={resourcesLink} />
                <div className="mobileFilterWrapperContainer">
                    <div className={wrapperClass}>
                        <button onClick={handleClick} type="button" className={navTitle ? "filterHead" : ""}>
                            {navTitle}
                        </button>
                        <div className={sectionClass}>
                            {mobileNested}
                            {mobileNoNested}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);
/* eslint-enable react/display-name */
export default MobileFilter;
